import { render, staticRenderFns } from "./FixedDepositImport.vue?vue&type=template&id=3c1b9e54"
import script from "./FixedDepositImport.vue?vue&type=script&lang=js"
export * from "./FixedDepositImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports